import {
  UPDATE_TIMEOUT,
  UPDATE_TYPE,
  UPDATE_MESSAGE,
  UPDATE_ACTIVE,
  NOTIFICATION_START,
  NOTIFICATION_END,
  CLEAR_TYPE,
  CLEAR_MESSAGE,
  CLEAR_ACTIVE,
  DEFAULT_NOTIFICATION_ACTION,
  DEFAULT_ERROR_CODE,
  WARNING_CODE
} from './constants'
import {
  notifyError,
  notifyInfo,
  notifySuccess,
} from './utils'

const errorNotificationAction = (detail) => ({
  type: DEFAULT_NOTIFICATION_ACTION,
  error: {
    code: DEFAULT_ERROR_CODE,
    detail
  }
})

const warningNotificationAction = (detail) => ({
  type: DEFAULT_NOTIFICATION_ACTION,
  error: {
    code: WARNING_CODE,
    detail
  }
})

const defaultNotificationAction = (message) => ({ type: DEFAULT_NOTIFICATION_ACTION, message })
const updateTimeout = (timeout) => ({ type: UPDATE_TIMEOUT, timeout })
const updateType = (value) => ({ type: UPDATE_TYPE, value })
const updateMessage = (message) => ({ type: UPDATE_MESSAGE, message })
const updateActive = (active) => ({ type: UPDATE_ACTIVE, active })
const notificationStart = () => ({ type: NOTIFICATION_START })
const notificationEnd = () => ({ type: NOTIFICATION_END })
const clearType = () => ({ type: CLEAR_TYPE })
const clearMessage = () => ({ type: CLEAR_MESSAGE })
const clearActive = () => ({ type: CLEAR_ACTIVE })

// Default Notifications
const error = notifyError(errorNotificationAction)
const warning = notifyError(warningNotificationAction)
const success = notifySuccess(defaultNotificationAction)
const info = notifyInfo(defaultNotificationAction)

export {
  defaultNotificationAction,
  notificationStart,
  notificationEnd,
  updateTimeout,
  updateType,
  updateMessage,
  updateActive,
  clearType,
  clearMessage,
  clearActive,
  error,
  success,
  info,
  warning
}
